// extracted by mini-css-extract-plugin
export var marginNegative = "_6g-5 _6g-3 _6g-1";
export var marginPositive = "_6g-4 _6g-3 _6g-1";
export var modalContent = "_6g-6";
export var samplesTable = "_6g-8";
export var samplesTableContainer = "_6g-7";
export var statBox = "_6g-a";
export var tableCell = "_6g-1";
export var tableCellCenter = "_6g-2 _6g-1";
export var tableCellRight = "_6g-3 _6g-1";
export var tableHeader = "_6g-0";
export var trackingNumber = "_6g-9";